import { useState, useEffect } from "react";

export function SmallLogo() {
    return <img src="../logos/jeddie-logo_white.png" className="logo" />;
}

export default function Logo() {
    return <img src="../logos/Jeddie_Logo_2023_1000px_photos.png" className="logo" />
}